import aws from './aws';
import { format } from 'date-fns';
import { cdnUrl as CDN_URL } from 'utils/constants';

export const useEmailHelper = () => {
  const timezone = format(new Date(), 'zzz');

  const emailEnums = {
    INVITE_NOTIIFCATION: 'invite_notification',
    ACCEPT_NOTIIFCATION: 'accept_notification',
    DELETE_BR_NOTIFICATION: 'delete_notification',
    //BAN_NOTIFICATION: 'ban_notification',
  };

  const defaultData = {
    brandName: '',
    brandMessage: '',
    targets: [],
    breakoutRoom: {
      topic: '',
      date: new Date(),
      start: new Date(),
      end: new Date(),
    },
    langcode: 'it',
  };

  // const sendBanEmail = async (data = defaultData) => {
  //   return await sendEmail(emailEnums.BAN_NOTIFICATION, data);
  // };

  const sendEmail = async (type, data = defaultData) => {
    const mail_type = type;
    const mail_to = data.targets;
    const brand_message = data.brandMessage;
    const brand_name = data.brandName;
    const br_topic = data.breakoutRoom.name;
    const br_image = `${CDN_URL}/${data.breakoutRoom.coverImage}`;
    const br_date = parseDate(data.breakoutRoom.date);
    const br_start = parseDate(data.breakoutRoom.start);
    const br_end = parseDate(data.breakoutRoom.end);
    const langcode = data.langcode;
    const is_live_chat = data?.is_live_chat;

    aws.API.sendMail(
      mail_type,
      mail_to,
      brand_message,
      brand_name,
      br_date,
      br_topic,
      br_image,
      br_start,
      br_end,
      timezone,
      langcode,
      is_live_chat
    );
  };

  const sendAgendaEmail = async ({ type, data }) => {
    const {
      userName,
      userLastname,
      userEmail,
      userSalesforceId,
      userCompany,
      brandName,
      brandSalesforceId,
      brandEmail,
      date,
      start,
      end,
      pavillion,
      stand,
      referentName,
      note,
    } = data;

    aws.API.sendMailAgenda(
      userName,
      userLastname,
      userEmail,
      userSalesforceId,
      userCompany,
      brandName,
      brandSalesforceId,
      brandEmail,
      date,
      start,
      end,
      pavillion,
      stand,
      referentName,
      note,
      type
    );
  };

  const parseDate = (date) => {
    let d = date;
    try {
      d = new Date(date);
    } catch (e) {
      console.log(e);
    }
    return d.toISOString();
  };

  return { sendEmail, emailEnums, sendAgendaEmail };
};
